// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

function mockUser() {
  return {
    id: "mock-user-id",
    name: "mock-name-id",
    organizationName: "mock-organization-name",
    profilePictureUri: undefined,
    username: "mock-username",
    canUseImpersonation: false,
    impersonating: false
  };
}

function mockShop(idOpt, nameOpt, corporateNameOpt, emailOpt, countryOpt, tvaNumberOpt, siretNumberOpt, amountOfShareCapitalOpt, kindOpt, logoUriOpt, loyaltyAddonActivatedOpt, param) {
  let id = idOpt !== undefined ? idOpt : "mock-shop-id";
  let name = nameOpt !== undefined ? nameOpt : "mock-shop-name";
  let corporateName = corporateNameOpt !== undefined ? corporateNameOpt : "mock-shop-corporateName";
  let email = emailOpt !== undefined ? emailOpt : "mock-shop-email";
  let country = countryOpt !== undefined ? countryOpt : "mock-shop-country";
  let tvaNumber = tvaNumberOpt !== undefined ? Primitive_option.valFromOption(tvaNumberOpt) : "mock-shop-tvaNumber";
  let siretNumber = siretNumberOpt !== undefined ? Primitive_option.valFromOption(siretNumberOpt) : "mock-shop-siretNumber";
  let amountOfShareCapital = amountOfShareCapitalOpt !== undefined ? Primitive_option.valFromOption(amountOfShareCapitalOpt) : "mock-shop-amountOfShareCapital";
  let kind = kindOpt !== undefined ? kindOpt : "INTEGRATED";
  let logoUri = logoUriOpt !== undefined ? Primitive_option.valFromOption(logoUriOpt) : undefined;
  let loyaltyAddonActivated = loyaltyAddonActivatedOpt !== undefined ? loyaltyAddonActivatedOpt : true;
  return {
    id: id,
    kind: kind,
    name: name,
    corporateName: corporateName,
    address: "mock-shop-address",
    postalCode: "mock-shop-postal-code",
    city: "mock-shop-city",
    country: country,
    phoneNumber: "0629831744",
    email: email,
    legalRepresentative: "mock-shop-legal-representative",
    logoUri: logoUri,
    activeWebDeviceId: "mock-shop-active-web-device-id",
    loyaltyAddonActivated: loyaltyAddonActivated,
    bankName: "mock-shop-bankName",
    cityOfRegistryOffice: "mock-shop-cityOfRegistryOffice",
    website: "mock-shop-website",
    fiscalYearEndClosingMonth: "december",
    legalForm: "mock-shop-legalForm",
    amountOfShareCapital: amountOfShareCapital,
    tvaNumber: tvaNumber,
    siretNumber: siretNumber,
    rcsNumber: "mock-shop-rcsNumber",
    apeNafCode: "mock-shop-apeNafCode",
    bankCode: "mock-shop-bankCode",
    bankAccountHolder: "mock-shop-bankAccountHolder",
    bankAccountNumber: "mock-shop-bankAccountNumber",
    bicCode: "mock-shop-bicCode",
    ibanNumber: "mock-shop-ibanNumber",
    invoicingEndpointId: "mock-shop-invoicingEndpointId",
    invoicingEndpointIdSchemeCode: "mock-shop-invoicingEndpointIdSchemeCode",
    invoicingEndpointIdSchemeType: "FR_SIREN",
    taxationRegime: "NORMAL_QUARTERLY",
    employeesNumber: "FROM_1_TO_10"
  };
}

function mockAuthState(activeShopOpt, shopsOpt, param) {
  let activeShop = activeShopOpt !== undefined ? Primitive_option.valFromOption(activeShopOpt) : mockShop(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let shops = shopsOpt !== undefined ? shopsOpt : [mockShop(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)];
  return {
    user: {
      id: "mock-user-id",
      name: "mock-name-id",
      organizationName: "mock-organization-name",
      profilePictureUri: undefined,
      username: "mock-username",
      canUseImpersonation: false,
      impersonating: false
    },
    shops: shops,
    activeShop: activeShop
  };
}

function mockAuthOrganisationScope(activeShopOpt, shopsOpt, param) {
  let activeShop = activeShopOpt !== undefined ? Primitive_option.valFromOption(activeShopOpt) : undefined;
  let shops = shopsOpt !== undefined ? shopsOpt : [
      mockShop(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
      mockShop(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)
    ];
  return {
    TAG: "Organisation",
    activeShop: activeShop,
    shops: shops
  };
}

function mockAuthSingleScope(shopOpt, param) {
  let shop = shopOpt !== undefined ? shopOpt : mockShop(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  return {
    TAG: "Single",
    _0: shop
  };
}

export {
  mockUser,
  mockShop,
  mockAuthState,
  mockAuthOrganisationScope,
  mockAuthSingleScope,
}
/* No side effect */
